import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';
import InstitutionForm from './InstitutionForm/InstitutionForm';
import InstitutionList from './InstitutionList/InstitutionList';
import { ORGANIZATION_INSTITUTION_FORM_URL } from '../../../../../constants';
import {
  postStopApi,
  setStopApi,
} from '../../../../../services/StopApi/StopApi';
import {
  getSaveCancel,
  getFormSuccess,
  getCancelPopup,
} from '../../../../common/commonUtils/commonUtils';

const Institution = (props) => {
  const { control, defaultValue, register, errors, useFunction } = props;
  const { handleSubmit } = useFunction;

  const [user, setUser] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [isNewInstitutionForm, setIsNewInstitutionForm] = useState(false);

  const organizationForm = useSelector((state) => state.organizationForm);
  const {
    newOrganizationForm,
    orgId,
    orgKey,
    organizationName,
    alternateName,
    accountingContactId,
    facilityCoordinatorContactId,
    parentOrganizationId,
    administrativeContactId,
    invoiceVerificationContactId,
    orgCity,
    wCare,
    parole,
    prison,
    other,
    cbp,
    sap,
    stop,
    vendor,
    inactive,
    orgDateCreate,
    orgDateEdit,
    orgCreatedById,
    orgEditedById,
  } = organizationForm;

  const organizationInstitutionForm = useSelector(
    (state) => state.organizationInstitutionForm
  );
  const { prisonCode, prisonNumber, gender, orgInstitutionSapList } =
    organizationInstitutionForm;

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { cityList } = organizationReferenceData;

  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const getOrgCityName = () => {
    const getOrgCity = cityList.find((item) => item.id === orgCity);
    return getOrgCity.id;
  };

  const onSubmit = () => {
    const url = `${ORGANIZATION_INSTITUTION_FORM_URL}`;
    const authorization = user?.signInUserSession.accessToken.jwtToken;
    const payload = {
      orgId: newOrganizationForm ? 0 : orgId,
      orgKey: orgKey,
      organizationName: organizationName,
      alternateName: alternateName,
      accountingContactId: accountingContactId ? accountingContactId : null,
      facilityCoordinatorContactId: facilityCoordinatorContactId
        ? facilityCoordinatorContactId
        : null,
      city: orgCity ? getOrgCityName() : null,
      parentOrganizationId: parentOrganizationId ? parentOrganizationId : null,
      administrativeContactId: administrativeContactId
        ? administrativeContactId
        : null,
      invoiceVerificationContactId: invoiceVerificationContactId
        ? invoiceVerificationContactId
        : null,
      wCare: wCare,
      parole: parole,
      prison: prison,
      other: other,
      cbp: cbp,
      sap: sap,
      stop: stop,
      vendor: vendor,
      inactive: inactive,
      orgDateCreate: orgDateCreate,
      orgDateEdit: orgDateEdit,
      orgCreatedById: orgCreatedById ? orgCreatedById : null,
      orgEditedById: orgEditedById ? orgEditedById : null,
      prisonCode: prisonCode,
      prisonNumber: prisonNumber,
      gender: gender ? gender : null,
    };
    if (newOrganizationForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewInstitutionForm(true);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewInstitutionForm(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  return (
    <>
      <InstitutionForm
        control={control}
        defaultValue={defaultValue}
        register={register}
        errors={errors}
      />
      {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit))}
      {newOrganizationForm ? (
        ''
      ) : (
        <InstitutionList
          orgId={orgId}
          orgInstitutionSapList={orgInstitutionSapList}
        />
      )}
      {getFormSuccess(formSuccess, setFormSuccess, isNewInstitutionForm)}
      {getCancelPopup(cancelPopUp, setCancelPopUp)}
    </>
  );
};

export default Institution;
